export enum Layouts {
	Hud = 'hud',
	GasStation = 'gasStation',
	PlayerVehicles = 'playerVehicles',
	Login = 'login',
	ServerPassword = 'serverPassword',
	ClosedBeta = 'closedBeta',
	VehicleShop = 'vehicleShop',
	Bank = 'bank',
	Hedit = 'hedit',
	Handling = 'handling',
	RadialMenu = 'radialMenu',
	Jobs = 'jobs',
	DrivingSchool = 'drivingSchool',
	PhotoMode = 'photoMode',
	Notification = 'notification',
	PropertyExchange = 'propertyExchange',
	PlateBuying = 'plateBuying',
	CharacterCreation = 'characterCreation',
	CharacterEditor = 'characterEditor',
	HomeBuying = 'homeBuying',
	Tuning = 'tuning',
	TuningTester = 'tuningTester',
	Modal = 'modal',
	ClothesShop = 'clothesShop',
	ClothesTester = 'clothesTester',
	HousesEditor = 'housesEditor',
	CarPaint = 'carPaint',
	VehiclePassport = 'vehiclePassport',
	Dialogs = 'dialogs',
	VehicleService = 'vehicleService',
	Offers = 'offers',
	MainMenu = 'mainMenu',
	GreenScreen = 'greenScreen',
	Tablet = 'tablet',
	DeathScreen = 'deathScreen',
	CarMarket = 'carMarket',
	BanScreen = 'banScreen',
	BarberShop = 'barberShop',
	TattooShop = 'tattooShop',
	ProductShop = 'productShop',
	LootBuyers = 'lootBuyers',
	VehicleRegistration = 'vehicleRegistration',
	HobbyFishing = 'hobbyFishing',
	GameFruits = 'gameFruits',
	Phone = 'phone',
	CharacterSelect = 'characterSelect',
	SpawnSelect = 'spawnSelect',
	TechTuning = 'techTuning',
	Workbench = 'workbench',
	Documents = 'documents',
	HelpModal = 'helpModal',
	CatchRing = 'catchRing',
	RockPaperScissors = 'rockPaperScissors',
	Feedback = 'feedback',
	FeedbackLight = 'feedbackLight',
	TuningStudio = 'tuningStudio',
	Runcode = 'runcode',
	Promo = 'promo',
	DonateItem = 'donateItem',
	AdminPanel = 'adminPanel',
	BetaRewards = 'betaRewards',
	Screen = 'screen',
}
